/**
 * Récépissé de déclaration d'achat repris de la DA faite via Skipcar.
 *
 * Arbitrage François `parcours_alternatif_pieces` du 09/09/2026, sur EQ-060-GD :
 * « seulement le récépissé de déclaration d'achat est manquant mais il a été
 * fait dans la partie DA, c'est pour cela il faut une équivalence si la DA a été
 * faite via SKIPCAR ». Le dossier CTVO réclamait à l'agence une pièce que
 * Skipcar détenait déjà, et le Parcours A restait bloqué pour rien.
 *
 * On ne lève PAS le blocage : on FOURNIT la pièce. Le récépissé existe
 * réellement (2352 des 2371 DA terminées en portent un en base), il est
 * matérialisé dans le slot `recepisse_da` comme s'il avait été déposé — la
 * règle `recepisse_da_manquant_parcours_a` se tait alors d'elle-même, et le
 * dossier part à l'ANTS avec sa pièce, pas avec une exception.
 *
 * Le document n'a pas d'extraction OCR : ses champs sont vides, exactement
 * comme les slots virtuels des fichiers multi-pièces. Les règles qui lisent son
 * CONTENU (chronologie DA ↔ cession, immatriculation du récépissé) restent donc
 * silencieuses, ce qui est le comportement voulu : on affirme la présence de la
 * pièce, pas ce qu'elle contient.
 */

import type { CgOcrResponse } from '../FormCGIA/ocr/ocrResponseTypes';
import type { UploadedDocResult } from '../FormCGIA/store/useFormCGIAStore';

export interface DaReceiptPayload {
  daRegistrationId: number;
  url: string;
  fileName: string | null;
  purchaseDateTime: string | null;
}

export const buildRecepisseDaDoc = (daReceipt?: DaReceiptPayload | null): UploadedDocResult | null => {
  const url = daReceipt?.url?.trim();
  if (!url) return null;

  return {
    docType: 'recepisse_da',
    firebaseUrls: [url],
    ocrResponse: {
      docTypeDetected: 'recepisse_da',
      docTypeMatch: true,
      docTypeMatchConfidence: 1,
      unreadable: false,
      // Trace de provenance : ce récépissé ne vient pas du dépôt de l'agence.
      warnings: ['recepisse_da_repris_de_la_da_skipcar'],
      fields: {} as CgOcrResponse['fields'],
    },
  };
};
